// =============================================================================
// PROJECT STORY — Toggle "read full story" description + active nav buttons
// =============================================================================

let toggle = null;
let description = null;
let observer = null;

function handleToggle() {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';

    if (expanded) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('is-open');
        toggle.textContent = `${toggle.dataset.labelDefault} ▼`;
        description.style.height = `${description.scrollHeight}px`;
        description.offsetHeight; // eslint-disable-line no-unused-expressions
        description.classList.remove('is-open');
        description.classList.add('is-closing');

        function onTransitionEnd(e) {
            if (e.propertyName !== 'height') return;
            description.removeEventListener('transitionend', onTransitionEnd);
            description.classList.remove('is-closing');
            description.style.height = '';
            description.hidden = true;
        }
        description.addEventListener('transitionend', onTransitionEnd);
    } else {
        description.hidden = false;
        // Force reflow before adding class so animation triggers
        description.offsetHeight; // eslint-disable-line no-unused-expressions
        description.classList.add('is-open');
        toggle.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = `${toggle.dataset.labelExpanded} ▲`;
    }
}

// -----------------------------------------------------------------------------
// Section nav: highlight button matching the section currently in view

function initSectionNav() {
    const sections = ['project-info', 'project-gallery', 'project-credits']
        .map(id => document.getElementById(id))
        .filter(Boolean);

    if (!sections.length) return;

    const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '100',
        10
    );

    const visible = new Set();

    function updateActive() {
        // Among visible sections, pick the one whose top is closest to (but below) the header
        let active = null;
        let minDistance = Infinity;
        visible.forEach(section => {
            const top = section.getBoundingClientRect().top;
            const distance = Math.abs(top - headerHeight);
            if (distance < minDistance) {
                minDistance = distance;
                active = section;
            }
        });

        sections.forEach(section => {
            const btn = document.querySelector(`.project-header__nav-btn[href="#${section.id}"]`);
            if (btn) btn.classList.toggle('project-header__nav-btn--active', section === active);
        });
    }

    observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    visible.add(entry.target);
                } else {
                    visible.delete(entry.target);
                }
            });
            updateActive();
        },
        {
            rootMargin: `-${headerHeight + 32}px 0px -40% 0px`,
            threshold: 0,
        }
    );

    sections.forEach(section => observer.observe(section));
}

export function init() {
    toggle      = document.querySelector('.project-info__toggle');
    description = document.getElementById('project-description');

    if (toggle && description) {
        toggle.addEventListener('click', handleToggle);
    }

    initSectionNav();
}

export function destroy() {
    if (toggle) {
        toggle.removeEventListener('click', handleToggle);
    }
    if (observer) {
        observer.disconnect();
        observer = null;
    }
    toggle      = null;
    description = null;
}
